// @flow
import * as React from 'react';

export type FileComponents = {[string]: React.Element<any>};
export type FileContent = {|
  [string]: string,
|};
